// @ts-nocheck
import { useVote } from "@/lib/hooks/useVote"
import { cn } from "@/lib/utils/cn"

export function VoteButtons({ postId, userId, currentVote, score, onVoteChange, size = "md", orientation = "vertical" }: any) {
  const { vote, score: s, isVoting, castVote } = useVote({
    targetId: postId, targetType: "post",
    initialVote: currentVote, initialScore: score,
    userId, onVoteChange,
  })

  const fmt = (n: number) => n >= 1000 ? (n/1000).toFixed(1)+"k" : String(n)

  if (orientation === "horizontal") {
    return (
      <div className="flex items-center gap-1">
        <button onClick={() => castVote("up")} disabled={isVoting}
          className={cn("vote-btn", vote === "up" && "active-up")}>
          <ArrowUp size={size} />
        </button>
        <span className={cn("vote-score text-xs font-bold", vote === "up" && "up", vote === "down" && "down")}>{fmt(s)}</span>
        <button onClick={() => castVote("down")} disabled={isVoting}
          className={cn("vote-btn", vote === "down" && "active-down")}>
          <ArrowDown size={size} />
        </button>
      </div>
    )
  }

  return (
    <div className="vote-col">
      <button onClick={() => castVote("up")} disabled={isVoting} className={cn("vote-btn", vote === "up" && "active-up")}>
        <ArrowUp size={size} />
      </button>
      <span className={cn("vote-score", vote === "up" && "up", vote === "down" && "down")}>{fmt(s)}</span>
      <button onClick={() => castVote("down")} disabled={isVoting} className={cn("vote-btn", vote === "down" && "active-down")}>
        <ArrowDown size={size} />
      </button>
    </div>
  )
}

function ArrowUp({ size }: { size: string }) {
  return (
    <svg className={size === "sm" ? "w-3 h-3" : "w-4 h-4"} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7"/>
    </svg>
  )
}
function ArrowDown({ size }: { size: string }) {
  return (
    <svg className={size === "sm" ? "w-3 h-3" : "w-4 h-4"} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
    </svg>
  )
}
